import CaretDown from "./SVG/caretDown.svg?react";

const CaretDownIcon = () => {
  return <CaretDown />;
};

export default CaretDownIcon;
